module.exports = __webpack_public_path__ + "h5/img/manu.85e6f050.png";